(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["meet-favorite-jeweler"] && !Shopify.designMode) return;
  try {
    
// FAQ accordion bespoke about
function meetFavoriteJeweler() {
  var newWindowWidth = $(window).width();
  var isMobile = newWindowWidth < 641;
  var $accordionTitles = $(".meet-favorite-jeweler-title");
  var $accordionDescriptions = $(".meet-favorite-jeweler-description");

  $accordionDescriptions.show();

  if (isMobile) {
    $accordionTitles.off('click').on('click', function() {
      var $parent = $(this).parent();
      var $description = $(this).next(".meet-favorite-jeweler-description");

      $description.slideToggle(300);
      $parent.toggleClass('active');
    });
  } else {
    $accordionTitles.off('click');
  }
}
  $(document).ready(function(){
    meetFavoriteJeweler();
  });

  $( window ).resize(function() {
    meetFavoriteJeweler();
  });

// FAQ accordion bespoke about end

  } catch(e) { console.error(e); }
})();
})();
